export default "__VITE_ASSET__dLapO_P9__";